import GlobalHeader from './global-header'

export default GlobalHeader
